import { render } from "./TabItem.vue?vue&type=template&id=30ac7c36"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__